import { PrivacyPolicyPage } from "@/features/privacy/privacy-policy-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/privacy")({
  component: PrivacyPolicyPage,
});
